import axios from "axios";
import authHeader from '../../../authheader'

const PEREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/IndividualPeReinstatement";

const getEmployment = (reinstatementId) => {
    return axios.get(`${PEREINSTATEMENTURL}/employment`, { headers: authHeader(), params: { reinstatementId } });
}
const postEmployment = (data) => {
    return axios.post(`${PEREINSTATEMENTURL}/employment`, data, { headers: authHeader() });
}
export default {
    getEmployment,
    postEmployment
}